var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        "custom-class": "related-ai-from-window",
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.AssociationBusinessInformationSI"),
        "close-on-click-modal": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          _vm.innerVisible = false
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            class:
              "tabs-container" +
              (_vm.canOperateJob ? "" : " cannot-operate-job")
          },
          [
            _c("span", { staticClass: "lab-state" }, [
              _vm._v(_vm._s(_vm.labState))
            ]),
            _c(
              "el-tabs",
              {
                ref: "tabs",
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleTabClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _vm.currentRow && !_vm.currentRow.masterFlag
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "tabBookingFCL",
                          label: _vm.$t("SeaExport.ImportOperation")
                        }
                      },
                      [
                        _c("tab-booking-fcl", {
                          ref: "tabBookingFCL",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentRow && _vm.currentRow.masterFlag
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "tabBookingMaster",
                          label: _vm.$t("SeaExport.ImportOperation")
                        }
                      },
                      [
                        _c("tab-booking-master", {
                          ref: "tabBookingMaster",
                          attrs: { context: _vm.context, action: _vm.action }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }